import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { COMPANY } from "@/data/site";

export default function WhatsappFloat() {
  const url = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent("Hi TamilBTC, I'd like to know more.")}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 left-6 z-40 w-14 h-14 lg:w-16 lg:h-16 bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center rounded-full shadow-lg wa-pulse transition-colors"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
}
